import { useMemo, useState } from 'react';
import { Drawer, useMediaQuery } from '@mui/material';
import { SelectAutocomplete } from '../../shared/components/form/select-autocomplete';
import { Button } from '../../button/block';
import { __, getCookie } from '../../shared/tools';
import Close from '../../assets/icons/close';
import clsx from 'clsx';
import style from './style.module.scss';

export const CountryPanel = ({
    panelOpen,
    setPanelOpen,
    languages,
    countries,
    activeLang,
    activeCountry,
    ...props
}) => {
    const [language, setLanguage] = useState(activeLang);
    const [country, setCountry] = useState(getCookie('shipping_country') ?? 'FR');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const isMobile = useMediaQuery(`(max-width:${style.mobileBreakpoint})`);

    const toggle = (panelOpen) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setPanelOpen(!panelOpen);
    };

    const languagesOptions = useMemo(() => {
        return languages.map((language) => {
            return {
                label: language.native_name,
                value: language.code,
            };
        });
    }, [languages]);

    const drawerStyle = {
        '& .MuiModal-backdrop, & .MuiDrawer-paper': {
            top: 'auto',
            height: isMobile ? 'calc(100vh - 73px)' : 'calc(100vh - 140px)',
            bottom: '0',
        },
        '& .MuiDrawer-paper': {
            padding: '2rem',
            boxShadow: 'none',
            maxInlineSize: '520px',
            inlineSize: '100%',
            backgroundColor: style.primary50,
        },
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);

        const newLanguage = languages.find((lang) => {
            return lang.code === language;
        });

        if (!newLanguage) {
            setError(__('Une erreur est survenue.'));
            setLoading(false);
            return false;
        }

        const separator = newLanguage.url.includes('?') ? '&' : '?';
        window.location.href = newLanguage.url + separator + 'shipping_country=' + country;
        // window.location.href = '/' + (language === 'fr' ? '' : language + '/') + '?shipping_country=' + country;
    };

    return (
        <Drawer
            className={clsx(style.panel, props.className)}
            anchor="right"
            open={panelOpen}
            onClose={toggle(true)}
            sx={drawerStyle}
        >
            <span className={style.title}>{__('Veuillez sélectionner votre langue et votre pays')}</span>
            <Close className={style.close} color={style.primary500} onClick={toggle(true)} />
            <form className={style.form} onSubmit={handleSubmit}>
                {languagesOptions && languagesOptions.length > 0 && (
                    <div className={style.formGroup}>
                        <label className={clsx(style.label)} htmlFor="language">
                            {__('Langue')}
                            <span className={style.required}>*</span>
                        </label>
                        <SelectAutocomplete
                            id="language"
                            required={true}
                            name="language"
                            label={__('Langue')}
                            options={languagesOptions}
                            value={language}
                            onChange={(val) => setLanguage(val)}
                        />
                    </div>
                )}
                {countries && countries.length > 0 && (
                    <div className={style.formGroup}>
                        <label className={clsx(style.label)} htmlFor="country">
                            {__('Pays')}
                            <span className={style.required}>*</span>
                        </label>
                        <SelectAutocomplete
                            id="country"
                            required={true}
                            name="country"
                            label={__('Pays')}
                            options={countries}
                            value={country}
                            onChange={(val) => setCountry(val)}
                        />
                    </div>
                )}

                <Button
                    text={__('Enregistrer mes préférences')}
                    tagName="button"
                    isSubmit={true}
                    className={style.button}
                    type="filled"
                    color={style.primary500}
                    disabled={loading}
                />
            </form>
            {error.length > 0 && <p className={style.error}>{error}</p>}
        </Drawer>
    );
};
